module.exports = __webpack_public_path__ + "img/lead-send-invite.fa0ff248.svg";